@for (member of members; track member; let i = $index) {
    <div class="mb-2">
      <app-single-team-member [team_member]="member" [removable]="memberIsRemovable"
                              (removeTeamMemberEvent)="removeTeamMember(member?.id)" [process_role_field]="false"
                              [teamMemberCustomFields]="teamMemberCustomFields" />
    </div>
}

<div class="row justify-content-center mb-3 mt-5">
  <button matButton="filled" class="rounded" color="primary" (click)="addTeamMember()">
    {{ "components.decision-table.new-decision-table.compile-proposal.add-team-member" | translate }}
  </button>
</div>

<div class="row justify-content-center my-3">
  <button matButton="filled" color="primary" class="rounded mr-3" (click)="openImportModal()">
    <mat-icon class="mr-2">file_copy</mat-icon>
    {{'generic.import-survey-team' | translate}}
  </button>
  <button matButton="filled" color="accent" class="rounded" (click)="openChartsModal()">
    <mat-icon class="mr-2">group_add</mat-icon>
    {{'components.decision-table.new-decision-table.compile-proposal.import-team-members-from-chart' | translate}}
  </button>
</div>
